const routePatterns: string[] = [
  '/a/[slug]',
  '/about/press/[slug]',
  '/l/[slug]',
  '/learn/[categoryname]/page/[pid]',
  '/learn/[categoryname]/[slug]',
  '/dynamic-route-test/[slug]',
  '/authors/page/[page]',
  '/author/page/[page]',
  '/learn/[categoryname]',
]

/**
 * Example Usage:
 *
 * // Matches '/a/[slug]'
 * getDynamicPath('/a/some-advertorial')
 * // Returns: "/a/[slug]"
 *
 * // Matches '/about/press/[slug]'
 * getDynamicPath('/about/press/company-news')
 * // Returns: "/about/press/[slug]"
 *
 * // Matches '/l/[slug]'
 * getDynamicPath('/l/some-lander')
 * // Returns: "/l/[slug]"
 *
 * // Matches '/learn/[categoryname]/[slug]'
 * getDynamicPath('/learn/debt-management/how-to-pay-off-loans')
 * // Returns: "/learn/[categoryname]/[slug]"
 *
 * // No matching pattern, return original pathname
 * getDynamicPath('/contact')
 * // Returns: "/contact"
 *
 * // No matching pattern, return original pathname
 * getDynamicPath('/about/company')
 * // Returns: "/about/company"
 */
export function getDynamicPath(pathname: string): string {
  for (const pattern of routePatterns) {
    const regex = new RegExp('^' + pattern.replace(/\[.*?\]/g, '([^/]+)') + '$')
    if (regex.test(pathname)) {
      return pattern
    }
  }
  return pathname
}

/**
 * Extracts dynamic parameters from a pathname based on the matched route pattern.
 *
 * @param pathname - The current pathname
 * @returns An object containing extracted parameters as key-value pairs
 *
 * Example:
 * getDynamicParams('/learn/debt-management/how-to-pay-off-loans')
 * Returns: { categoryname: "debt-management", slug: "how-to-pay-off-loans" }
 */
export function getDynamicParams(pathname: string): Record<string, string> {
  for (const pattern of routePatterns) {
    const regex = new RegExp('^' + pattern.replace(/\[([^\]]+)\]/g, '([^/]+)') + '$')
    const match = pathname.match(regex)

    if (match) {
      const paramNames = [...pattern.matchAll(/\[([^\]]+)\]/g)].map((m) => m[1])
      const params: Record<string, string> = {}

      paramNames.forEach((name, index) => {
        params[name] = match[index + 1]
      })

      return params
    }
  }
  return {}
}
